// extracted by mini-css-extract-plugin
export default {"control":"Control_control__Wh1R4","button":"Control_button__UJow2"};